import { wallet } from '../types';

const INITIAL_STATE = {
    error: undefined
}

const walletreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case wallet.ADD_AMOUNT_TO_WALLET_SUCCESS:
            return {
                ...state,
                ongoingTransaction: action.payload
            }

        case wallet.GET_WALLET_DETAILS_SUCCESS:
            return {
                    ...state,
                    wallet: action.payload
                }    

        case wallet.RESET_WALLET_STORE_SUCCESS:
            return INITIAL_STATE

        case wallet.GET_WALLET_DETAILS_FAILURE:
        case wallet.UPDATE_WALLET_AFTER_PG_SUCCESS_FAILURE:
            return {
                ...state,
                error: action.payload
            }
        default:
            return {
                ...state
            }
    }
}


export default walletreducer